import React, { useCallback, useRef, useState } from "react";
import withAuth from "../../../../../../Hoc/withAuth";
import PageHeader from "../../../../../../Components/Bits/PageHeader";
import Reinitialize from "../../Admin/Evaluations/components/Reinitialize";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  Alert,
  Button,
  Card,
  Grid,
  LinearProgress,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import AlertPopup from "../../../../../../Components/Bits/AlertPopup";
// import CallRecordings from "./CallRecordings";
import Notes from "./Notes";
import EvaluationContentCard from "../../Admin/Evaluations/components/EvaluationContentCard";
import EditEvaluationForm from "../../Admin/Evaluations/components/EditEvaluationForm";
import AddLinkToEvaluation from "./AddLinkToEvaluation";
import CallRecordingsNew from "./CallRecordingsNew";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

const ViewEvaluationQAUser = ({ user }) => {
  const { id, evalID } = useParams();
  const [showForm, setShowForm] = useState(false);
  const [editEval, setEditEval] = useState(false);
  const [queues, setQueues] = React.useState([]);
  // const [callListeningTime, setCallListeningTime] = useState(0);

  // console.log("User: ", user);

  // --- Ref to store time without causing parent re-renders ---
  const callListeningTimeRef = useRef(0);

  const updateCallListeningTime = useCallback((time) => {
    // setCallListeningTime(time); // REMOVE or COMMENT OUT state update
    callListeningTimeRef.current = time; // Update the ref's value
    // console.log("Parent Ref Time Updated:", callListeningTimeRef.current); // Optional: for debugging
  }, []); // No dependencies needed

  // --- NEW: Stable function to GET the current time from the ref ---
  const getCurrentListeningTime = useCallback(() => {
    return callListeningTimeRef.current;
  }, []); // No dependencies, ref changes don't trigger re-renders

  const config = {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  };

  // const getTranscription = useMutation(["googleTranscript"], () => {
  //   return axios.post(`${process.env.REACT_APP_API_URL}/transcribe`, {});
  // });

  const getCallRecordings = useQuery([`Recordings${evalID}`], () => {
    return axios.get(
      `${process.env.REACT_APP_API_URL}/QAInbound/admin/${evalID}/recording`,
    );
  });

  const Recordings = getCallRecordings.data?.data?.data;

  const getEvaluationByID = useQuery({
    queryKey: ["getEvaluationByID", evalID],
    queryFn: async () =>
      await axios.get(
        `${process.env.REACT_APP_API_URL}/QAInbound/user/${evalID}`,
        config,
      ),
  });

  const evaluation = getEvaluationByID.data?.data?.data;

  const updateEvaluation = useMutation({
    mutationFn: (data) =>
      axios.put(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/Evaluations/${id}/evaluations/${evalID}`,
        data,
        config,
      ),
    onSuccess: () => {
      getEvaluationByID.refetch();
      setShowForm(false);
    },
  });

  const startEvaluation = useMutation({
    mutationFn: (data) =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/results/startEvaluation`,
        data,
      ),
    onSuccess: () => {
      setShowForm(true);
    },
  });

  const endEvaluation = useMutation({
    mutationFn: (data) =>
      axios.post(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/results/endEvaluation`,
        data,
      ),
    onSuccess: () => {
      getEvaluationByID.refetch();
      setShowForm(false);
    },
  });

  useQuery({
    queryKey: ["getQueuess", id],
    queryFn: async () =>
      await axios.get(
        `${process.env.REACT_APP_API_URL}/QAInbound/admin/campaign/callcentercampaign/${evaluation?.call_centre_campaign_id}`,
      ),
    enabled:
      !getEvaluationByID.isLoading && !!evaluation?.call_centre_campaign_id,
    onSuccess: (data) => {
      console.log("Queues data: ", data);
      setQueues(
        data?.data?.data?.filter(
          (campaignQueue) => campaignQueue?.qa_campaign?.active === true,
        ),
      );
    },
  });

  // const AutoSaveEvaluation = useMutation({
  //   mutationFn: (data) =>
  //     axios.post(
  //       `${process.env.REACT_APP_API_URL}/QAInbound/admin/results/endEvaluation`,
  //       data
  //     ),
  //   onSuccess: () => {
  //     getEvaluationByID.refetch();
  //   },
  // });

  const stableSetShowForm = useCallback((value) => {
    setShowForm(value);
  }, []);

  const evaluationState = ({ status }) => {
    switch (status) {
      case "New":
        return "Start Evaluation";
      case "Busy":
        return "Continue Evaluation";
      case "Failed":
        return "Redo Failed Evaluation";
      case "Completed":
        return "Completed";
      default:
        return "New";
    }
  };

  // console.log("getTranscription", getTranscription);

  const handleStartEvaluation = useCallback(() => {
    if (evaluation) {
      startEvaluation.mutate(evaluation);
    } else {
      console.error("Cannot start evaluation, evaluation data is missing.");
    }
  }, [evaluation, startEvaluation]);

  if (getEvaluationByID.isLoading) {
    return <LinearProgress />;
  }

  if (getEvaluationByID.isError) {
    return (
      <div>Error loading evaluation: {getEvaluationByID.error.message}</div>
    );
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <PageHeader
          title="QA User"
          subheader="Manage your QA evaluations"
          breadcrumbs={[
            { title: "Home", href: "/" },
            { title: "QA User", href: "/CDA/inbound/user" },
          ]}
        />
        {/* <Button
          onClick={() => getTranscription.mutate()}
          variant="contained"
          color="error"
          sx={{ mb: 2, mt: 2 }}
        >
          Get Transcription
        </Button> */}
        <Grid container height={1} spacing={2}>
          <Grid item xs={12}>
            {editEval ? (
              <Button
                variant="contained"
                color="inherit"
                onClick={() => setEditEval(false)}
              >
                Close
              </Button>
            ) : (
              <Button
                variant="outlined"
                color="secondary"
                fullWidth
                disabled={evaluation.status === "Completed" ? true : false}
                onClick={() => setEditEval(true)}
              >
                Edit Evaluation
              </Button>
            )}

            {evaluation && (
              <>
                {editEval ? (
                  <EditEvaluationForm
                    evaluation={evaluation}
                    // users={users}
                    getEvaluationByID={getEvaluationByID}
                    // allQueues={allQueues}
                    queues={queues}
                    nonAdmin={true}
                  />
                ) : (
                  <EvaluationContentCard
                    evaluation={evaluation}
                    queues={queues}
                  />
                )}
              </>
            )}
          </Grid>

          <Grid item xs={12}>
            <Notes
              evaluation={evaluation}
              updateEvaluation={updateEvaluation}
            />
          </Grid>
        </Grid>

        <Stack sx={{ mt: 2 }}>
          {evaluation.evaluation_type === "Ticket" &&
            evaluation.Link === null && (
              <>
                <Alert severity="error">
                  This evaluation is a ticket Ticket Evaluations require a Link
                  to be attached to them.
                </Alert>
                <AddLinkToEvaluation
                  updateEvaluation={updateEvaluation}
                  getEvaluationByID={getEvaluationByID}
                />
              </>
            )}
          {(evaluation.evaluation_type === "Inbound Call" ||
            evaluation.evaluation_type === "Outbound Call") &&
            Recordings?.length === 0 && (
              <Alert severity="error">
                This evaluation is a call evaluation. Call Evaluations require a
                Call Recording to be attached to them.
              </Alert>
            )}
        </Stack>

        {(evaluation.evaluation_type === "Inbound Call" ||
          evaluation.evaluation_type === "Outbound Call") && (
          <>
            {/* <CallRecordings
              getCallRecordings={getCallRecordings}
              callListeningTime={callListeningTime}
              updateCallListeningTime={updateCallListeningTime}
              evaluation={evaluation}
              showForm={showForm}
            /> */}
            <CallRecordingsNew
              getCallRecordings={getCallRecordings}
              // callListeningTime={callListeningTime}
              updateCallListeningTime={updateCallListeningTime}
              evaluation={evaluation}
              showForm={showForm}
            />
            {/* <Typography variant="h6">
              Call Listening Time : {callListeningTime}
            </Typography> */}
          </>
        )}

        {evaluation.evaluation_type === "Ticket" && (
          <Card
            sx={{
              p: 2,
              mt: 2,
              border: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="h6" gutterBottom>
              Link Attached to Evaluation
            </Typography>
            <Link
              href={evaluation.Link}
              target="_blank"
              rel="noopener noreferrer"
            >
              {evaluation?.Link}
            </Link>
          </Card>
        )}

        <>
          {!showForm ? (
            <>
              {evaluation.evaluation_type === "Ticket" ? (
                <Button
                  variant="contained"
                  color={evaluation.status === "Busy" ? "warning" : "success"}
                  fullWidth
                  sx={{ mb: 2, mt: 2 }}
                  disabled={
                    evaluation.status === "Completed"
                      ? true
                      : false ||
                        (evaluation.evaluation_type === "Ticket" &&
                          evaluation?.Link === null)
                  }
                  onClick={handleStartEvaluation}
                >
                  {evaluationState({ status: evaluation.status })}
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color={evaluation.status === "Busy" ? "warning" : "success"}
                  fullWidth
                  sx={{ mb: 2, mt: 2 }}
                  disabled={
                    evaluation.status === "Completed"
                      ? true
                      : false ||
                        ((evaluation.evaluation_type === "Inbound Call" ||
                          evaluation.evaluation_type === "Outbound Call") &&
                          Recordings?.length === 0)
                  }
                  onClick={handleStartEvaluation}
                >
                  {evaluationState({ status: evaluation.status })}
                </Button>
              )}
            </>
          ) : (
            <Reinitialize
              user={user}
              // setStart={setShowForm}
              setStart={stableSetShowForm}
              endEvaluation={endEvaluation}
              // AutoSaveEvaluation={AutoSaveEvaluation}
              evaluation={evaluation}
              getCurrentTime={getCurrentListeningTime}
            />
          )}
        </>
        {/* 
        {(evaluation.status === "Completed" ||
          evaluation.status === "Failed") &&
          showForm === false && <ViewEvaluationMetrics evaluationId={evalID} />} */}

        <AlertPopup
          open={updateEvaluation.isSuccess}
          message="Evaluation Updated"
          severity="warning"
        />

        <AlertPopup
          open={endEvaluation.isSuccess}
          message={"Success"}
          severity={"success"}
        />
      </div>
    </DndProvider>
  );
};

export default withAuth(ViewEvaluationQAUser);
